export default "  <ng-content #matchItem></ng-content>\n      <ng-content></ng-content>\n"